import { forwardRef, PropsWithChildren } from "react"

const SMERegistrationTerm = forwardRef<HTMLDivElement, PropsWithChildren<{}>>(
  (props, ref) => {
    return (
      <div
        ref={ref}
        className="flex h-full flex-col gap-y-2 overflow-y-scroll text-sm"
      >
        <h4 className="text-xl">
          <strong>회원가입 및 물품 운송 이용약관</strong>
        </h4>

        <p>
          <br />본 약관은 주식회사 브이투브이(이하 “을”)과 브이투브이가 제공하는
          택배 서비스(이하 “서비스”)를 이용하는 이용자(이하”갑”)의 관계를
          설명하며, 서비스 이용을 위해 아래의 약관 및 관련 운영 정책에
          동의하여야 합니다.
          <br />
        </p>

        <p className="mt-1">
          <strong>제 1 조 (목적)</strong>
          <br />
        </p>
        <p>
          본 이용약관은 “갑”으로부터 “을”이 물품 운송 용역을 의뢰 받아 “을”의
          책임하에 “갑”이 지정하는 수하인(이하 그 대리인을 포함한다)에게 물품을
          배송하기까지의 제반 업무에 관한 사항과 배송요금의 지급 및 청구권 등을
          정하는 데 그 목적이 있다.
          <br />
        </p>

        <p className="mt-1">
          <strong>제 2 조 (업무 범위)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “갑”의 수하인의 주소지가 “을”이 지정한 서비스 가능 지역에 포함되어
            있는 경우, “갑”이 지정하는 장소로부터 “을”이 물품을 인수한 후,
            “갑”의 수하인에게 이를 배송한다.
          </li>
          <li>
            당일배송 가능한 물품 규격 및 조건은 다음과 같다
            <ol
              className="list-inside pl-2"
              style={{ listStyleType: "hangul" }}
            >
              <li>
                박스 기준 삼변합 (가로 – 세로 – 높이)이 100cm 이하이면서 5kg
                이하인 상품
              </li>
              <li>상자 한 변의 최장 길이는 45cm 이내.</li>
              <li>배송 중 부패되거나 내용물이 변질될 위험이 없는 상품</li>
              <li>기타 상호 합의에 의해 배송 하기로 정한 상품</li>
              <li>
                배송 물품 도착지가 서울시, 인천시, 경기도 부천시로 한정한 상품
                (인천지역은 강화군, 옹진군 제외)
              </li>
              <li>물품가액 50만원 이하 접수 가능</li>
            </ol>
          </li>
          <li>
            익일배송 가능한 물품 규격은 다음과 같다. (구간별 물품 규격은 하단
            참조)
            <ol
              className="list-inside pl-2"
              style={{ listStyleType: "hangul" }}
            >
              <li>
                박스 기준 삼변합 (가로 – 세로 – 높이)이 140cm 이하이면서 15kg
                이하인 상품
              </li>
              <li>상자 한 변의 최장 길이는 60cm 이내</li>
              <li>배송 중 부패되거나 내용물이 변질될 위험이 없는 상품</li>
              <li>기타 상호 합의에 의해 배송 하기로 정한 상품</li>
              <li>물품가액 50만원 이하 접수 가능</li>
            </ol>
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 3 조 (물품 포장)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “갑”은 물품의 종류와 성질, 중량, 용적 등에 따라 운송에 적합하게
            가치를 최대한 안전하게 유지 보존할 수 있도록 포장하여 “을”에게 물품
            운송을 의뢰하여야 한다.
          </li>
          <li>
            “을”은 포장이 운송에 적합하지 아니한 때에는 “갑”에게 운송에 적합한
            포장을 하도록 요청할 수 있다.
          </li>
          <li>
            “갑”이 전 항의 요청을 이행하지 아니한 경우 “을”은 운송을 거절할 수
            있으며, “갑”이 전 항의 의무를 다하지 못하여 발생한 손해에 대하여
            “을”은 어떠한 손해배상 책임도 지지 않는다.
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 4 조 (집화)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “갑”은 “을”에게 전산 또는 서면으로 운송 작업을 위탁하여야 한다.
          </li>
          <li>
            또한 “갑” 또는 “을”의 불가피한 사정으로 인하여 제품의 출하 및 인수가
            불가능한 경우에는 상호 협의하여 익일에 집화, 인수할 수 있다.
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 5 조 (배 송)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “갑”이 의뢰한 물품은 배송 예정 기일 내에 “갑”의 수하인에게 배송하되
            휴일인 경우 또는 교통사정 등으로 배송이 곤란한 경우에는 그 사유가
            해소된 다음날까지 배송하는 것으로 한다.
          </li>
          <li>
            단, 물량증가 등의 부득이한 사정이 있거나 아래에 해당되는 경우는
            배송원칙의 예외로 한다.
            <ol
              className="list-inside pl-2"
              style={{ listStyleType: "hangul" }}
            >
              <li>
                천재지변 등의 불가항력적인 소요사태가 발생한 지역이나 산간오지,
                도서 지역.
              </li>
              <li>
                “을”이 지정하는 택배 성수기(설날, 추석, 연말연시, 공휴일 다음
                영업일 등)
              </li>
              <li>“을”이 지정하는 수하인의 사정으로 배송 불가할 경우</li>
            </ol>
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 6 조 (배송요금)</strong>
        </p>
        <p>
          물품의 종류와 성질, 중량, 용적, 가격, 배송지역에 따라 박스 단위로
          별첨에 정한 요금 단가를 적용하며, 이는 포장 단위별로 부착 발행된
          운송장에 의거하여 청구하고 정산한다.
        </p>
        <ol className="list-inside list-decimal">
          <li>
            구간별, 중량별, 물품 가액별 운임은 이용약관 운임표(별지첨부)에
            의한다
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 7 조 (배송요금의 지급 및 청구권 등)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “을”은 “갑”이 의뢰한 물품의 배송요금을 배송 접수 시 마다 선불
            충전금에서 제하고 ‘갑’에게 배송 접수 시스템을 통해 결제액을
            공지한다. ‘갑’은 ‘을’이 발급한 고정 가상계좌를 통해 선불 충전한
            포인트로 배송요금을 매회 지불한다.
          </li>
          <li>
            “갑”은 “을”이 정한 방식과 시스템을 통해서만 포인트의 구매가 가능하며
            구매한 포인트는 해당 사업자 계정에서 본인의 거래에 대해서만 사용할
            수 있다.
          </li>
          <li>
            “갑”이 미입금 또는 지체할 시에 “을”은 “갑”에 대하여 지급이행 독촉 및
            압류(가압류포함) 등의 보전, 법적 절차를 실시할 수 있으며, “갑”은
            이에 대하여 어떠한 이의제기를 할 수 없다.
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 8 조 (포인트의 구매)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            포인트란 회사에서 서비스하는 배송 접수 서비스를 이용하기 위해
            구매하는 인터넷상의 결제수단으로 현금 1원당 포인트 1원의 비율로
            환산되며, 사업자 계정을 기준으로 충전, 결제, 환불 등이 가능하다.
          </li>
          <li>
            “갑”은 “을”이 정한 결제 방식을 이용하여 일정 금액 단위로 ‘포인트’를
            유상 충전하여 사용할 수 있다. 포인트의 부여 및 사용에 관한 상세한
            사항은 “을”이 정한 정책에 따르며, “을”은 파트너 서비스 페이지에 관련
            링크 등을 통하여 이를 회원에게 안내한다.
          </li>
          <li>
            “갑”은 “을”이 제공하는 결제 방식을 통해 포인트를 구매 후 배송 접수
            시스템 내에서 물품 정보에 따라 차감 및 정산, 환불이 가능하며
            세금계산서 발행이 가능하다.
          </li>
          <li>
            유상으로 구매한 포인트의 경우 사용기간은 구매일로부터 1년이며, 이
            기간이 경과한 경우 포인트 사용권은 소멸된다. 다만, 포인트 사용 시
            회사의 서비스 변경, 종료 등으로 인하여 포인트를 더 이상 사용할 수
            없는 경우 남은 금액을 지정된 사업자 계좌로 환불한다.
          </li>
          <li>
            이용약관에 따라 차감되어야 하는 포인트 보다 현재 보유한 포인트가
            적은 경우 포인트는 마이너스로 표시 될 수 있으며 이는 “갑”이 “을”에게
            추가로 납부하여야 하는 금액을 의미한다.
          </li>
          <li>
            “갑”은 포인트를 사업자 계정에서만 이용할 수 있으며, 제3자에게 양도,
            대여, 매매 또는 환전 등을 할 수 없다. 다만, 회사가 별도로 정하여
            공지한 방법으로 이용이 발생하는 경우에는 사용이 가능하다.
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 9 조 (가상계좌 결제)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “을”은 “갑”에게 포인트 구매를 위한 결제 기능을 제공한다. 포인트 충전
            시 계정당 1개의 고정 가상계좌가 생성되며 입금이 완료되면 포인트가
            충전된다.
          </li>
          <li>
            “갑”은 결제 대금을 성실히 납부하여야 할 책임이 있다. 또한 “갑”은
            계정 관리의 책임을 가지며 관리 소홀 및 부주의로 발생된 제3자의
            결제에 대해 “을”은 어떠한 책임도 부담하지 않는다.
          </li>
          <li>
            회사의 정책 및 결제업체(은행, PG사 등)의 정책, 방침 등에 따라 각
            결제수단별로 결제한도가 부여 또는 조정될 수 있다.
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 10 조 (청약 철회 및 환불)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “갑”은 구매한 포인트를 구매일로부터 1년 이내에 별도의 수수료 없이
            홈페이지 외 고객센터, 웹챗(인천 소상공인 채팅상담)을 통해
            청약철회(구매 취소)를 할 수 있다. 포인트 환불은 충전 금액 총액의
            환급, 혹은 잔여포인트 전액에 해당하는 금액의 환불만 가능하며 디지털
            자산 보호를 위해 최소 24시간 이후 환불이 가능하다.
          </li>
          <li>
            “갑”이 구매한 포인트에 대한 환불은 “갑”이 이용한 PG사의 환불 정책에
            따라 진행되며, 자세한 환불 신청절차는 “을”의 운영정책에 따른다. 또한
            구매한 포인트에 대한 환불이 완료된 경우에는 환불 금액만큼 포인트가
            차감된다.
          </li>
          <li>
            “을”은 포인트가 지급되지 않거나 구매 금액과 다르게 지급된 경우에는
            지체없이 원인을 파악하여 대응하고, 회원의 요구에 따라 환불을
            진행한다.
          </li>
          <li>
            “을”은 회사의 귀책 사유로 인하여 “갑”이 구매한 포인트를 이용하지
            못하는 경우, 해당 구매 금액을 구매일에 관계없이 전액 환불한다. 또한
            회사의 귀책 사유로 발생한 사고 건의 배송료 및 반송료의 경우 포인트를
            지체없이 반환한다. 단, “갑”이 청약철회 요청 시 포인트가 마이너스
            상태인 경우 “을”은 추가 운임료를 후불 청구할 수 있다.
          </li>
          <li>
            “갑”은 회사의 홈페이지 외 고객센터, 웹챗(인천 소상공인 채팅상담)을
            통해서 청약철회를 신청 할 수 있으나, 아래의 각 항에 해당하는 경우
            환불 받을 수 없다.
            <ol>
              <li>포인트의 유효기간이 경과하는 경우</li>
              <li>
                배송 접수 시 물품 정보가 상이하여 포인트가 추가 청구되어
                마이너스 상태가 된 경우
              </li>
              <li>
                회원이 보상, 또는 이벤트 등을 통하여 회사로부터 무상으로
                제공받은 포인트
              </li>
            </ol>
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 11 조 (손해 배상)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “갑”은 “을”이 물품의 수탁, 인도 보관 및 운송에 관하여 주의를 태만히
            하여 “갑”에게 물품의 멸실, 훼손 등의 손해가 발생한 경우 “을’에게 그
            손해의 배상을 청구 할 수가 있다.
          </li>
          <li>
            “을”의 귀책사유에 의한 물품의 분실로 인하여 “갑”이 입은 손해에
            대하여는 “을”은 분실 시 제품 원가(공장도가)를 기준으로 “을”이 전액
            배상함을 원칙으로 한다. “을”의 책임범위 및 그 손해배상액은
            이용약관내용에 기초하여 산정 한다.
          </li>
          <li>
            “갑”은 손해 발생 인지 후 1주일 이내에 배상청구를 하도록 하며, “을”은
            배상액 확정일로부터 사고 발생 익월 말일까지 이를 배상하여야 한다.
          </li>
          <li>
            손해 배상 상황 발생 시 “을”이 “갑”에게 지급해야 하는 배상액은 최대
            50만 원 까지로 한다.
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 12 조 (면 책)</strong>
        </p>
        <p>“을”은 다음 각 호에 해당하는 경우에는 그 책임을 면한다.</p>
        <ol className="list-inside list-decimal">
          <li>
            폭우, 폭설 등 천재지변, 기타 소요사태로 인한 배달지연 등의
            물품사고가 발생한 경우
          </li>
          <li>
            “갑” 또는 “갑”의 수하인이 배송 후 화물의 일부 멸실 또는 훼손 등의
            사고가 발생한 사실을 인지한 후 14일 이내에 “을”에게 알리지 아니한
            경우
          </li>
          <li>
            의뢰하는 물품의 종류와 성질, 중량, 용적, 가격 등이 이용약관내용과
            달리 변경되었음을 사전에 “을”에게 통지하지 아니하여 그로 인해 손해가
            발생된 경우
          </li>
          <li>
            “을”이 제공하는 서비스는 “갑”의 개별적 행위에 따라 다양한 결과가
            발생할 수 있으므로 “갑”의 취사선택 등으로 문제가 발생하는 경우
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 13 조 (이용약관 기간)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>본 이용약관 유효기간은 회원 탈퇴시까지 유효하다.</li>
        </ol>

        <p className="mt-1">
          <strong>제 14 조 (비밀보장)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            “을”은 물품 운송 업무를 수행하는 과정에서 알게 된 “상호”의 정보 및
            기밀 사항을 엄수하고, “상호“의 기업 이미지 및 품위를 손상하는 일이
            없도록 최선을 다한다.
          </li>
          <li>
            양 사 간 합의 및 이용약관된 서비스 운임, 서비스 조건 등의 영업 비밀
            사항들에 대해 “갑”은 외부 유출 또는 제 3자와 정보 공유를 할 수
            없으며, 관련 정보에 대한 보안 및 관리 책임을 진다.
          </li>
          <li>
            “갑“이 제2항을 위반할 경우 “을“은 이로 말미암아 발생한 영업 손실에
            대해 금전적 배상을 요구할 권리를 가지며, “갑”은 이를 수용하고 즉각
            배상하여야 한다.
          </li>
          <li>
            “을”은 포인트 충전과 관련한 “갑”의 정보를 본 이용계약상의 서비스
            제공을 위한 목적으로만 사용하며 “갑”의 사전 동의 없이 제 3자에게
            누설 또는 배포할 수 없다. 그러나 다음 각 호에 해당하는 경우에는
            예외로 한다.
            <ol>
              <li>서비스 제공에 따른 요금 정산을 위하여 필요한 경우</li>
              <li>
                통계작성·학술연구 또는 시장조사를 위하여 필요한 경우로서 특정
                개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
              </li>
              <li>
                금융실명거래및비밀보장에관한법률,
                신용정보의이용및보호에관한법률, 전기통신기본법, 전기통신사업법,
                지방세법, 소비자보호법, 한국은행법, 형사소송법 등 법률에 특별한
                규정이 있는 경우
              </li>
              <li>
                기타 개인정보 보호와 관련된 사항은 회사의 “개인정보 취급방침”에
                따른다.
              </li>
            </ol>
          </li>
        </ol>

        <p className="mt-1">
          <strong>제 15 조 (분쟁 해결)</strong>
        </p>
        <ol className="list-inside list-decimal">
          <li>
            본 이용약관에 명시되지 아니한 사항은 택배표준약관에 기반해 상호
            협의하여 해결하기로 한다.
          </li>
          <li>
            본 이용약관에 관하여 분쟁이 있는 경우에는 을의 소재지를 관할하는
            법원을 제1심의 전속관할로 한다.
          </li>
        </ol>

        <h4 className="mt-4 text-xl">
          <strong>서비스 운임표</strong>
        </h4>
        <p>
          위 정해진 상품 규격 및 기준을 현격히 초과할 경우, 집화 시 수탁이
          거부될 수 있습니다.
          <li>
            접수 불가 물품 출고 시, 최대 16,000원이 추가 청구 될 수 있습니다.
          </li>
          <li>
            지하철 천원택배 이용 시 월 최대 1000건까지 건별 배송비
            1,500원(포인트)이 추가로 할인됩니다.
          </li>
          <br />
          제주도 : 일반 운임 + 3,000원, 도서 산간 지역 : 운송 실비 청구
        </p>

        <div className="pb-6">
          <table className="w-full border border-black text-center">
            <tbody>
              <tr className="border border-black">
                <th className="border border-black">배송 크기타입</th>
                <th className="border border-black">당일</th>
                <th className="border border-black">일반</th>
                <th className="border border-black">일반택배 반품(+200원)</th>
                <th className="border border-black">아이스박스(반품X)</th>
              </tr>
              <tr className="border border-black">
                <td className="border border-black">소(100cm,5kg 이하)</td>
                <td className="border border-black">3,500원</td>
                <td className="border border-black">2,500원</td>
                <td className="border border-black">2,700원</td>
                <td className="border border-black">3,500원</td>
              </tr>
              <tr className="border border-black">
                <td className="border border-black">중(120cm,10kg 이하)</td>
                <td className="border border-black">접수불가</td>
                <td className="border border-black">3,500원</td>
                <td className="border border-black">3,700원</td>
                <td className="border border-black">4,100원</td>
              </tr>
              <tr className="border border-black">
                <td className="border border-black">대(140cm,15kg 이하)</td>
                <td className="border border-black">접수불가</td>
                <td className="border border-black">4,900원</td>
                <td className="border border-black">5,100원</td>
                <td className="border border-black">6,000원</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
)

SMERegistrationTerm.displayName = "SMERegistrationTerm"

export { SMERegistrationTerm }
